import { useMutation } from '@apollo/client';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { gql } from '__generated__';
import { FC, useState } from 'react';
import { useParams } from 'react-router-dom';

import Button from 'components/Button';
import { FormInput, FormPanel } from 'components/FormPanel';

import SearchUsers from './SearchUsers';

const CREATE_DEPARTMENT_ADMIN_MUTATION = gql(`
  mutation CreateDepartmentAdmin($userId: ID!, $departmentId: ID!) {
    createDepartmentAdmin(userId: $userId, departmentId: $departmentId) {
      id
      user {
        id
        fullName
      }
      role
      createdAt
      updatedAt
    }
  }
`);

const CreateDepartmentAdminDialogButton: FC = () => {
  const [showDialog, toggleDialog] = useState(false);
  const { departmentId } = useParams<{ departmentId: string }>() as { departmentId: string };

  const [createDepartmentAdmin, { loading, error }] = useMutation(
    CREATE_DEPARTMENT_ADMIN_MUTATION,
    {
      refetchQueries: ['DepartmentAdmins'],
    }
  );

  return (
    <>
      <Button onClick={() => toggleDialog(true)}>Add Department Admin</Button>
      <Dialog open={showDialog} onClose={() => toggleDialog(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Add a Department Admin</DialogTitle>
        <DialogContent sx={{ minHeight: '50vh' }}>
          <FormPanel
            loading={loading}
            error={error}
            onCancel={() => toggleDialog(false)}
            onSubmit={data => {
              createDepartmentAdmin({
                variables: {
                  userId: data.user.id,
                  departmentId: departmentId,
                },
              }).then(() => toggleDialog(false));
            }}
          >
            <FormInput
              fullWidth
              type="custom"
              fieldName="user"
              label="User"
              defaultValue={''}
              customInput={SearchUsers}
              validators={{
                required: true,
              }}
            />
          </FormPanel>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CreateDepartmentAdminDialogButton;
